module.exports = __webpack_public_path__ + "img/hat.b37893af.png";